import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
    dottedLoaderWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
});
